module.exports = __webpack_public_path__ + "img/clear.e4b24263.jpg";